<template>
  <div>
    <vs-card>
      <b-row align-h="start">
        <b-col lg="3" md="auto" style="padding-right: 2px">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="printStockForBarcode()"
          >
            <Icon
              icon="mdi:tag-outline"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("PrepareStockTicket") }}
          </b-button>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card class="vs-con-loading__container" id="loading-stockList">
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table-barcode-prt ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="stockColumns"
        :defaultColDef="defaultColDef"
        :rowData="stockList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        :pagination="true"
      >
      </ag-grid-vue>
    </vs-card>
    <vs-popup
      class="holamundo"
      :title="$t('PrintBroductBarcode')"
      :active.sync="isSidebarActiveLocal"
      @close="closePrintPopup"
      @cancel="closePrintPopup"
      fullscreen
    >
      <b-row>
        <b-col lg="4" v-if="templates">
          <b-row>
            <component
              :is="scrollbarTag"
              ref="scroll2"
              class="vs-input--label scroll-area--data-list-add-new-barcode-prt"
              :settings="settings"
              :key="$vs.rtl"
            >
              <b-row
                style="padding-right: 8px; padding-top: 15px"
                class="vs-con-loading__container"
                id="loading-item"
              >
                <b-col
                  lg="6"
                  style="padding-right: 2px"
                  v-for="(temp, ind) in templates"
                  :key="temp.TemplateDefinitionId"
                  v-on:click="
                    getSelectedTemplate(temp, ind);
                    getSelectedStockWithBarcode();
                  "
                >
                  <vs-card :class="temp.isSelected == 'selected' ? 'bg-success' : ''">
                    <div>
                      <b-row>
                        <b-col lg="3">
                          <b-button
                            v-on:click="
                              isSidebarActiveProcess = true;
                              deleteBarcode = temp;
                            "
                            size="sm"
                            variant="outline-light"
                          >
                            <Icon
                              icon="material-symbols:close"
                              width="25"
                              height="25"
                              v-b-tooltip.hover.bottom="$t('Delete')"
                              color="#ea5455"
                            />
                          </b-button>
                        </b-col>
                        <b-col lg="3">
                          <b-button
                            v-on:click="routeToUpdate(temp)"
                            size="sm"
                            variant="outline-light"
                          >
                            <Icon
                              icon="material-symbols:edit"
                              width="25"
                              height="25"
                              v-b-tooltip.hover.bottom="$t('Update')"
                              color="#065a82"
                            />
                          </b-button>
                        </b-col>
                        <b-col>
                          <b-button
                            v-on:click="routeToCopy(temp)"
                            size="sm"
                            variant="outline-light"
                          >
                            <Icon
                              icon="ph:copy"
                              width="25"
                              height="25"
                              v-b-tooltip.hover.bottom="$t('Copy')"
                              color="#ffcb77"
                            />
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                    <grid-layout
                      :layout="temp.TemplateDefinitionValue"
                      :col-num="12"
                      :row-height="1"
                      :is-draggable="false"
                      :is-resizable="false"
                      :vertical-compact="true"
                      :use-css-transforms="true"
                    >
                      <grid-item
                        v-for="item in temp.TemplateDefinitionValue"
                        :key="`${temp.TemplateDefinitionId}-${item.i}-${item.x}`"
                        :i="item.i"
                        :x="item.x"
                        :y="item.y"
                        :w="item.w"
                        :h="item.h"
                      >
                        <span class="text" v-if="item.barcode">
                          <barcode
                            :value="item.barcode"
                            format="CODE128"
                            :text-options="{ fontSize: 8 }"
                            style="width: 100%; height: 100%; text-align: center"
                          />
                        </span>
                        <div
                          class="grid-item-content"
                          style="text-align: center; font-size: 6px"
                          v-else-if="item.label"
                        >
                          {{ item.label }}
                        </div>
                        <div
                          class="grid-item-content"
                          style="text-align: center"
                          v-else-if="item.element == 'horizontalLine'"
                          :style="{ fontSize: item.fontSize + 'px' }"
                        >
                          <hr
                            style="width: 100%; height: 3px; border-top: 2px solid #000"
                          />
                        </div>
                        <div
                          class="grid-item-content"
                          style="text-align: center"
                          v-else-if="item.element == 'verticalLine'"
                          :style="{ fontSize: item.fontSize + 'px' }"
                        >
                          <div
                            class="vertical-line"
                            style="
                              width: 2px;
                              height: 100%;
                              background-color: #000;
                              margin: 0 auto;
                            "
                          ></div>
                        </div>
                        <span class="text" v-else style="font-size: 6px"
                          >{{ item.item }}
                        </span>
                      </grid-item>
                    </grid-layout>
                  </vs-card>
                </b-col>
              </b-row>
            </component>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <vs-card>
              <b-row>
                <b-col>
                  <div
                    v-if="parseInt(barcode_options.length) < 1"
                    id="loading-barcode"
                    class="vs-con-loading__container"
                    style="
                      height: 32px;
                      width: 190px;
                      border: 0.5px solid darkgrey;
                      border-radius: 5px;
                    "
                  ></div>
                  <v-select
                    v-else
                    color="danger"
                    v-model="selectedBarcode"
                    :options="barcode_options"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="customer"
                    v-validate="'required'"
                    @input="getSelectedStockWithBarcode"
                  >
                  </v-select>
                </b-col>
                <b-col>
                  <v-select
                    color="danger"
                    v-model="selectedBarcodeMatch"
                    :options="barcodematch_options"
                    size="small"
                    autocomplete
                    ref="selectElement"
                    name="customer"
                    :taggable="true"
                    @input="getSelectedStockWithBarcodeMatch"
                  >
                  </v-select>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('Width')"
                        class="vs-input--label pr-0 mr-0"
                        label-for="h-first-name"
                        style="font-weight: 600"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="width"
                        type="number"
                        class="w-full"
                        name="width"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('width')">{{
                        errors.first("width")
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <b-row>
                    <b-col cols="4" align-self="center">
                      <b-form-group
                        :label="$t('Height')"
                        class="vs-input--label pr-0 mr-0"
                        label-for="h-first-name"
                        style="font-weight: 600"
                      >
                      </b-form-group>
                    </b-col>
                    <b-col cols="8">
                      <vs-input
                        size="small"
                        v-model="height"
                        type="number"
                        class="w-full"
                        name="height"
                        v-validate="'required'"
                      />
                      <span class="text-danger text-sm" v-show="errors.has('height')">{{
                        errors.first("height")
                      }}</span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-row align-h="end">
                  <b-col lg="2">
                    <b-button
                      class="bg-primary mt-3"
                      style="border-color: white; width: 100%"
                      v-on:click="printBarcodeQty"
                    >
                      <Icon
                        icon="material-symbols:print-outline"
                        width="20"
                        height="20"
                      />
                      {{ $t("Print") }}</b-button
                    >
                  </b-col>
                </b-row>
              </b-row>
            </vs-card>
          </b-row>
          <b-row v-if="selectedTemp && findedStock">
            <div
              ref="printProductBarcode"
              :style="'width:' + width + 'px; height: ' + height + 'px'"
            >
              <vs-card :style="'width:' + width + 'px; height: ' + height + 'px'">
                <grid-layout
                  :layout="selectedTemp.TemplateDefinitionValue"
                  :col-num="12"
                  :row-height="10"
                  :is-draggable="false"
                  :is-resizable="false"
                  :vertical-compact="true"
                  :use-css-transforms="true"
                >
                  <grid-item
                    v-for="item in selectedTemp.TemplateDefinitionValue"
                    :key="`${selectedTemp.TemplateDefinitionId}-${item.i}-${item.x}`"
                    :i="item.i"
                    :x="item.x"
                    :y="item.y"
                    :w="item.w"
                    :h="item.h"
                  >
                    <span class="text" v-if="item.barcode">
                      <p style="text-align: center">
                        <barcode
                          v-if="item.barcode == 'MasterBarcode'"
                          :value="selectedBarcodeMatch"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        />
                        <barcode
                          v-else
                          :value="findedStock.Stock[item.barcode]"
                          format="CODE128"
                          :text-options="{ fontSize: 8 }"
                          style="width: 100%; height: 100%; text-align: center"
                        /> 
                      </p>
                    </span>
                    <span
                      class="text"
                      style="text-align: center"
                      v-else-if="item.label"
                      :style="{ fontSize: item.fontSize + 'px' }"
                      ><p style="text-align: center">{{ item.label }}</p>
                    </span>
                    <div
                      class="grid-item-content"
                      style="text-align: center"
                      v-else-if="item.element == 'horizontalLine'"
                      :style="{ fontSize: item.fontSize + 'px' }"
                    >
                      <hr style="width: 100%; height: 3px; border-top: 2px solid #000" />
                    </div>
                    <div
                      class="grid-item-content"
                      style="text-align: center"
                      v-else-if="item.element == 'verticalLine'"
                      :style="{ fontSize: item.fontSize + 'px' }"
                    >
                      <div
                        class="vertical-line"
                        style="
                          width: 2px;
                          height: 100%;
                          background-color: #000;
                          margin: 0 auto;
                        "
                      ></div>
                    </div>
                    <span
                      class="text"
                      style="text-align: center"
                      v-else
                      :style="{ fontSize: item.fontSize + 'px' }"
                      ><p style="text-align: center" v-if="item.item == 'Date'">
                        {{ getToday() }}
                      </p>
                      <p style="text-align: center" v-else-if="findedStock">
                        {{ findedStock.Stock[item.item] }}
                      </p>
                      <p style="text-align: center" v-else></p>
                    </span>
                  </grid-item>
                </grid-layout>
              </vs-card>
            </div>
          </b-row>
        </b-col>
      </b-row>

      <vs-prompt
        :title="$t('Warning')"
        :acceptText="$t('Submit')"
        :cancelText="$t('Cancel')"
        @accept="deletesubmit"
        :active.sync="isSidebarActiveProcess"
        color="danger"
      >
        <div style="text-align: center" class="con-exemple-prompt">
          <span>
            <b-row style="margin-top: 15px">
              <b-col cols="12" align-self="center">
                <h6>{{ $t("DoConfirm") }}</h6>
              </b-col>
            </b-row>
          </span>
        </div>
      </vs-prompt>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { GridLayout, GridItem } from "vue-grid-layout";
import Barcode from "vue-barcode";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import moment from "moment";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  components: {
    VuePerfectScrollbar,
    AgGridVue,
    Icon,
    vSelect,
    GridLayout,
    GridItem,
    Barcode,
    detailBtnCellRenderer,
  },
  data() {
    return {
      barcodeMatchValidate: false,
      barcodematch_options: [],
      selectedBarcodeMatch: "",
      quantity: 0.0,
      width: 0.0,
      height: 0.0,
      isSidebarActiveLocal: false,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      selectedBarcode: "",
      printData: [],
      deleteBarcode: "",
      isSidebarActiveProcess: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,
      customer: "",
      templates: [],
      eventLog: [],
      stockList: [],
      stockColumns: [],
      barcode_options: [],
      mainLayout: [],
      findedStock: null,
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      selectedTemp: "",
    };
  },
  methods: {
    routeToCopy(temp) {
      this.isSidebarActiveLocal = false;
      const url = this.$router.resolve({
        name: "barcode-printing-modules",
        params: {
          data: JSON.stringify(temp),
          copy: true,
        },
      }).href;
      window.open(url, "_blank");
    },
    routeToUpdate(temp) {
      this.isSidebarActiveLocal = false;
      const url = this.$router.resolve({
        name: "barcode-printing-modules",
        params: {
          data: JSON.stringify(temp),
        },
      }).href;
      window.open(url, "_blank");
    },
    getToday() {
      let today = new Date();
      return moment(String(today)).format("DD.MM.YYYY hh:mm:ss");
    },
    printBarcodeQty() {
      const printContents = this.$refs.printProductBarcode.innerHTML;
      const printWindow = window.open("", "", "height=600,width=800");
      printWindow.document.write("<html><head><title>Print</title>");
      printWindow.document.write("</head><body >");
      printWindow.document.write(printContents);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.print();
    },
    getSelectedTemplate(item, ind) {
      this.selectedTemp = item;
      this.width = this.selectedTemp.TemplateDefinitionWith;
      this.height = this.selectedTemp.TemplateDefinitionHeight;
      this.templates.forEach((val, index) => {
        this.templates[index].isSelected = "";
      });
      this.templates[ind].isSelected = "selected";
      this.mainLayout = this.selectedTemp.TemplateDefinitionValue;
    },
    getSelectedStockWithBarcodeMatch() {
      this.barcodeMatchValidate = true;
    },
    getSelectedStockWithBarcode() {
      this.barcodeMatchValidate = false;
      this.findedStock = this.stockWithBarcodes.find(
        (item) => item.StockBarcodeId == this.selectedBarcode.value
      );
    },
    closePrintPopup() {
      this.findedStock = null;
      this.selectedTemp = [];
      this.selectedBarcode = "";
      this.selectedBarcodeMatch = "";
      this.barcodeMatchValidate = false;
    },
    getStockWithBarcodesList() {
      const vs = this.$vs;
      let type = "material";
      setTimeout(() => {
        vs.loading({
          container: `#loading-barcode`,
          type,
          scale: 0.5,
        });
      }, 500);

      this.barcode_options = [];
      this.$store
        .dispatch("stock/listStockWithBarcodes", this.printData.CompanyId)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-barcode > .con-vs-loading");
            }, 1000);
            try {
              let stockJson = JSON.parse(response.json);
              let filteredData = stockJson.filter(
                (item) => item.Stock.StockId == this.printData.StockId
              );
              filteredData.forEach((val, index) => {
                this.barcode_options.push({
                  name: val.Barcode,
                  value: val.StockBarcodeId,
                });
              });
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else {
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            setTimeout(() => {
              vs.loading.close("#loading-barcode > .con-vs-loading");
            }, 1000);
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-barcode > .con-vs-loading");
          }, 1000);
          console.log(error);
        });
    },
    getBarcodeMatchingList() {
      const vs = this.$vs;
      this.barcode_options = [];
      this.$store
        .dispatch("stock/listStockMatching")
        .then((response) => {
          if (response.success == true) {
            try {
              let stockJson = JSON.parse(response.json);

              this.barcodematch_options = stockJson;
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printBarcode() {
      this.isSidebarActiveLocal = true;
      this.getTemplateList();
      this.getStockWithBarcodesList();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    deletesubmit() {
      const vs = this.$vs;
      this.$store
        .dispatch("template/deleteTemplate", this.deleteBarcode.TemplateDefinitionId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getTemplateList();
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    printStockForBarcode() {
      window.open(
        this.$router.resolve({ name: "barcode-printing-modules" }).href,
        "_blank"
      );
    },
    getStockList() {
      const vs = this.$vs;
      this.stockList = [];
      this.stockColumns = [];
      this.stockList = this.stock;
      this.stockListFiltered = this.stock;
      let type = "material";
      vs.loading({
        container: `#loading-stockList`,
        type,
        scale: 0.75,
      });
      if (this.stockList.length > 0) {
        setTimeout(() => {
          vs.loading.close("#loading-stockList > .con-vs-loading");
        }, 1000);
        let columnList = Object.keys(this.stockList[0]);
        this.stockColumns.push({
          width: 100,
          pinned: "right",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "printBarcode",
            iconDetail: "material-symbols:print-outline",
            iconColor: "#065a82",
          },
        });
        columnList.forEach((val, index) => {
          if (
            val == "DepotName" ||
            val == "Stockno" ||
            val == "CustomerStockNo" ||
            val == "CompanyName" ||
            val == "StockName" ||
            val == "CompanyInfoName"
          ) {
            this.stockColumns.push({
              width: 150,
              headerName: this.$t(val),
              field: val,
              pinned: "left",

              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          } else if (val == "Status")
            this.stockColumns.push({
              width: 80,
              headerName: this.$t(val),
              cellRendererFramework: "statusShowCellRenderer",
              field: val,
              filter: "agSetColumnFilter",
            });
          else if (
            val != "ActSupplierId" &&
            val != "DepotId" &&
            val != "CompanyInfoId" &&
            val != "CompanyId" &&
            val != "StockId" &&
            val != "UnitId" &&
            val.toString().includes("Date") == false
          )
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "TextViewCellRenderer",
            });
          else if (val.toString().includes("Date") == true) {
            this.stockColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY HH:mm");
    },

    getTemplateList() {
      const vs = this.$vs;
      let type = "material";
      vs.loading({
        container: `#loading-item`,
        type,
        scale: 0.75,
      });
      this.$store
        .dispatch("template/listTemplatesForCompany", this.printData.CompanyId)
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-item > .con-vs-loading");
            }, 1000);
            try {
              let datas = JSON.parse(response.json);
              datas.forEach((val, index) => {
                let lcItem = JSON.parse(val.TemplateDefinitionValue);
                datas[index].TemplateDefinitionValue = lcItem;
                lcItem.forEach((value, ind) => {
                  datas[index].TemplateDefinitionValue[ind].i = datas[
                    index
                  ].TemplateDefinitionValue[ind].i.toString();

                  datas[index].TemplateDefinitionValue[ind].static = true;
                });
              });
              this.templates = datas;
              this.selectedTemp = this.templates[0];
              this.width = this.templates[0].TemplateDefinitionWith;
              this.height = this.templates[0].TemplateDefinitionHeight;
              this.templates.forEach((val, index) => {
                this.templates[index].isSelected = "";
              });
              this.templates[0].isSelected = "selected";
              this.mainLayout = this.templates[0].TemplateDefinitionValue;
            } catch (error) {
              vs.notify({
                text: error.toString(),
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-item > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-item > .con-vs-loading");
          }, 1000);
          console.log(error);
        });
    },
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },

    stock: {
      get() {
        return this.$store.state.stock.Stock;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stock: {
      get() {
        return this.$store.state.stock.Stock;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stockWithBarcodes: {
      get() {
        return this.$store.state.stock.StockWithBarcodes;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },

  watch: {
    templates(val) {
      return val;
    },

    stock(val) {
      this.getStockList();
      return val;
    },
    stockWithBarcodes(val) {
      return val;
    },
  },
  mounted() {
    this.templates = [];
    this.getStockList();
    this.getBarcodeMatchingList();
    this.$root.$on("printBarcode", (data) => {
      this.printData = data;
      this.printBarcode(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("printBarcode");
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table-barcode-prt {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 210px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  background: #eee;
}

.vue-grid-item:not(.vue-grid-placeholder) {
  background: #ccc;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 0;
  left: 0;
  background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>")
    no-repeat;
  background-position: bottom right;
  padding: 0 8px 8px 0;
  background-repeat: no-repeat;
  background-origin: content-box;
  cursor: pointer;
}
.vue-barcode-element {
  height: 100%;
  width: 100%;
}
.scroll-area--data-list-add-new-barcode-prt {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 90px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
.con-vs-dialog {
  z-index: 520055;
}
.vertical-line {
  width: 2px;
  height: 100%;
  background-color: #000;
  margin: 0 auto;
}
@media print {
  .vertical-line {
    width: 2px;
    height: 100%;
    background-color: #000;
    margin: 0 auto;
  }
}
</style>
